import React from "react";
import { Typography, useMediaQuery, useTheme, Grid } from "@mui/material";

const CountdownTimer = (props) => {
  const { days, hours, minutes, seconds } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const timerComponent = (value, type) => (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <Grid
        container
        sx={[
          {
            width: isMobile ? "50px" : "80px",
            height: isMobile ? "50px" : "80px",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "14px",
            border: `1px solid ${theme.branding.cyan[600]}`,
            background: `linear-gradient(135deg, #FFFFFF33 0%, #0099AA33 100%)`, //gray[0] 20% opacity to cyan[700] 20% opacity
            boxShadow: `0 4px 6px -1.2px #33DDEE33, 0 1.6px 2.4px -1.6px #0099AA33`, //cyan[300] 20% opacity to cyan[700] 20% opacity
          },
          (theme) =>
            theme.applyStyles("dark", {
              borderColor: theme.branding.cyan[300],
              background:
                "linear-gradient(135deg, #33DDEE33 0%, #0099AA33 100%)", //cyan[300] 20% opacity to cyan[700] 20% opacity
            }),
        ]}
      >
        <Typography
          variant="h3"
          sx={[
            {
              background: `linear-gradient(135deg, ${theme.branding.cyan[700]} 0%, ${theme.branding.darkBlue[600]} 100%)`,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: isMobile ? "24px" : "30px",
            },
            (theme) =>
              theme.applyStyles("dark", {
                background: `linear-gradient(135deg, ${theme.branding.cyan[300]} 0%, ${theme.branding.gray[0]} 100%)`,
              }),
          ]}
        >
          {value}
        </Typography>
      </Grid>
      <Typography
        variant="caption"
        sx={{
          color: theme.branding.gray[500],
          fontSize: "12px",
          textAlign: "center",
        }}
      >
        {type}
      </Typography>
    </Grid>
  );

  return (
    <Grid
      container
      direction="row"
      wrap="nowrap"
      sx={{
        gap: "12px",
      }}
    >
      {timerComponent(days, "Days")}
      {timerComponent(hours, "Hours")}
      {timerComponent(minutes, "Minutes")}
      {seconds && timerComponent(seconds, "Seconds")}
    </Grid>
  );
};

export default CountdownTimer;
